import { useState, useEffect } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';
import { initOfflineSync, setSyncStatusCallback, syncPendingOperations } from '@/lib/syncService';

export default function OfflineIndicator() {
  const [status, setStatus] = useState(navigator.onLine ? 'online' : 'offline');

  useEffect(() => {
    setSyncStatusCallback(setStatus);
    initOfflineSync();
  }, []);

  if (status === 'online') return null;

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-300",
        status === 'offline' && "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
        status === 'syncing' && "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
        status === 'pending' && "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
        status === 'error' && "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
      )}
      data-testid="offline-indicator"
    >
      {status === 'offline' && (
        <>
          <WifiOff className="h-3 w-3" />
          <span>Offline Mode</span>
        </>
      )}
      {status === 'syncing' && (
        <>
          <RefreshCw className="h-3 w-3 animate-spin" />
          <span>Syncing...</span>
        </>
      )}
      {status === 'pending' && (
        <>
          <RefreshCw className="h-3 w-3" />
          <span>Changes pending</span>
          <button onClick={syncPendingOperations} className="underline ml-1">Retry</button>
        </>
      )}
      {status === 'error' && (
        <>
          <WifiOff className="h-3 w-3" />
          <span>Sync error</span>
          <button onClick={syncPendingOperations} className="underline ml-1">Retry</button>
        </>
      )}
    </div>
  );
}
